var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrownlblog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6364 7.6364C16.9879 7.28492 16.9879 6.71508 16.6364 6.3636L10.9088 0.636039C10.5574 0.284567 9.98751 0.284567 9.63604 0.636039C9.28457 0.987511 9.28457 1.55736 9.63604 1.90883L14.7272 7L9.63604 12.0912C9.28457 12.4426 9.28457 13.0125 9.63604 13.364C9.98751 13.7154 10.5574 13.7154 10.9088 13.364L16.6364 7.6364ZM-1.23738e-09 7.9L16 7.9L16 6.1L1.23738e-09 6.1L-1.23738e-09 7.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrownlblog);
export default __webpack_public_path__ + "static/media/arrownlblog.675a56b4e8f9d461767e32e751ba9327.svg";
export { ForwardRef as ReactComponent };